
import CustomerIndex from '../components/customers/CustomerIndex.vue';
import Vue from 'vue';

Vue.component('customer-index', CustomerIndex);

export default Vue.extend({});
